(function () {
  var form = document.getElementById('ContactForm');
  if (!form) return;

  var ORDER_RELATED_TOPIC_KEYS = ['order', 'returns'];

  var topicSelect = document.getElementById('ContactForm-topic');
  var orderWrapper = document.getElementById('ContactForm-order-wrapper');

  function syncOrderField() {
    if (!topicSelect || !orderWrapper) return;
    var selected = topicSelect.options[topicSelect.selectedIndex];
    var topicKey = selected ? selected.getAttribute('data-topic-key') : null;
    orderWrapper.hidden = ORDER_RELATED_TOPIC_KEYS.indexOf(topicKey) === -1;
  }

  if (topicSelect && orderWrapper) {
    topicSelect.addEventListener('change', syncOrderField);
    syncOrderField();
  }

  var textarea = document.getElementById('ContactForm-body');
  var counter = document.getElementById('ContactForm-body-count');
  if (textarea && counter) {
    var max = textarea.getAttribute('maxlength');
    var updateCount = function () {
      counter.textContent = textarea.value.length + ' / ' + max;
    };
    textarea.addEventListener('input', updateCount);
    updateCount();
  }

  var honeypot = form.querySelector('[name="contact[Website]"]');

  form.addEventListener('submit', function (event) {
    if (honeypot && honeypot.value.trim() !== '') {
      event.preventDefault();
      return;
    }

    var button = form.querySelector('.contact2__submit');
    if (button && !button.disabled) {
      button.disabled = true;
      if (button.dataset.loadingText) {
        button.textContent = button.dataset.loadingText;
      }
    }
  });
})();
